import type { DialogContext } from './actions';

import * as ActionTypes from 'src/state/action-types';

export interface IUIState {
  showDialog: {
    [key: string]: {
      show: boolean;
      context?: DialogContext | { runId?: string };
    };
  };
  showLoadingIndicator: {
    [key: string]: boolean;
  };
  clipboardCutFromFolderId: string;
}

export const initialState: IUIState = {
  showDialog: {},
  showLoadingIndicator: {},
  clipboardCutFromFolderId: '',
};

export default function UIReducer(
  state: IUIState = initialState,
  action: ActionTypes.ActionTypes
): IUIState {
  switch (action.type) {
    case ActionTypes.UI_SHOW_DIALOG:
      return {
        ...state,
        showDialog: {
          ...state.showDialog,
          [action.payload.key]: {
            show: true,
            context: action.payload.context,
          },
        },
      };

    case ActionTypes.CONTENT_DELETE_REQUEST:
      return {
        ...state,
        showLoadingIndicator: {
          ...state.showLoadingIndicator,
          deleteContent: true,
        },
      };

    case ActionTypes.CONTENT_DELETE_SUCCESS:
      return {
        ...state,
        showDialog: {
          ...state.showDialog,
          deleteContent: {
            show: false,
          },
        },
        showLoadingIndicator: {
          ...state.showLoadingIndicator,
          deleteContent: false,
        },
      };

    case ActionTypes.UI_HIDE_DIALOG:
      return {
        ...state,
        showDialog: {
          ...state.showDialog,
          [action.payload.key]: {
            show: false,
          },
        },
      };

    case ActionTypes.FOLDERS_DELETE_SUCCESS:
      return {
        ...state,
        showDialog: {
          ...state.showDialog,
          deleteFolder: {
            show: false,
          },
        },
      };

    case ActionTypes.UI_CLIPBOARD_CUT:
      return {
        ...state,
        clipboardCutFromFolderId: action.payload.cutFromFolderId,
      };

    case ActionTypes.FOLDERS_CUT_AND_PASTE_SUCCESS:
      return {
        ...state,
        clipboardCutFromFolderId: '',
      };

    default:
      return state;
  }
}
